/**
 * Lyric Boost Design System - Token Exports
 * 
 * Central export point for all design tokens.
 * Import tokens from this file to ensure consistency.
 */

export { colors } from './colors';
export type { ColorTokens } from './colors';

export { typography, typographyVariants } from './typography';
export type { Typography, TypographyVariants } from './typography';

export { spacing } from './spacing';
export type { Spacing } from './spacing';

// Re-export everything as a single tokens object for convenience
import { colors } from './colors';
import { typography, typographyVariants } from './typography';
import { spacing } from './spacing';

export const tokens = {
  colors,
  typography,
  typographyVariants,
  spacing,
} as const;
